
import { eventBus, EVENTS } from '../commons/EventBus.js';
import { Slider } from '../commons/slider.js';
import API from "../commons/Api.js";
import Utils from "../commons/utils.js";

eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
    const template=data.template;

    if((template!='magazine'&&template!='magazine-category')||data.refresh){
        return;
    }

    if(data.subtemplates.single_first_trending[0] == null && data.subtemplates.single_content_trending.length == 0) {
        $("#magazine-blocco-in-evidenza-container").remove();
    }

    $('#toggle_select_categoria, #toggle_select_categoria-cat').on('click', (e)=>{
        $(".option_select_container").slideToggle();
        $("#toggle_select_categoria").find(".icon_dropdown").toggleClass("open");
        $("#toggle_select_categoria-cat").find(".icon_dropdown").toggleClass("open");
    });

    new Slider({
        total: $(".single_slide_home").length,
        paginator_cont: $("#paginator_slider_magazine"),
        cssVar: '--slider_magazine',
        slide_cont: 'slide_container_magazine',
        swipeElementSelector: '#magazine-simple_slide'});

});

$(document).on('click','#mostra_altri_magazine', (e)=>{
    e.preventDefault();
    Utils.showWaitingLoader();
    const qParams=Utils.getParams();
    const curPage=qParams.page||1;
    const nextPage=Number(curPage)+1;
    qParams.page=nextPage;
    const newUrl=location.href.split('?')[0] + '?' + Utils.objectToQParams(qParams);
    let NUM_POSTS = parseInt($("#mostra_altri_magazine").attr("data-num-posts"));
    let start_paginatore = parseInt($("#mostra_altri_magazine").attr("data-start")) + NUM_POSTS;
    let id_categoria = parseInt($("#mostra_altri_magazine").attr("data-id"));
    API.get("site/getLastPostsByCategory", {id: id_categoria, numero_post: NUM_POSTS, start:start_paginatore }, function (resp) {
        var recenti = resp.data;
        if(recenti.length > 0){
            for (let i = 0; i < recenti.length; i++) {
                let template = window.templates["simple_post_recenti"];
                template =  template.replace(/{{image}}/g, recenti[i].image)
                                    .replace(/{{category}}/g, recenti[i].category)
                                    .replace(/{{date}}/g, recenti[i].date)
                                    .replace(/{{title}}/g, recenti[i].title)
                                    .replace(/{{slug}}/g, recenti[i].slug);

                $("#magazine-simple_post_recenti").append(template);
            }
            $("#mostra_altri_magazine").attr("data-start", start_paginatore);
            if(recenti[0]['category_count']<=NUM_POSTS+start_paginatore){
                $(".container_mostra_altri_hide").hide();
            }
        } else{
            // $("#mostra_altri_magazine").hide();
            $(".container_mostra_altri_hide").hide();
        }

        history.pushState({page: newUrl}, '', newUrl);
        qParams.page=Number(nextPage)+1;
        $('#mostra_altri_magazine .scopri_orizzontale_blue').attr('href',location.pathname + '?' + Utils.objectToQParams(qParams));
        Utils.hideWaitingLoader();

    });

});
